import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import AddOrder from "./AddOrder";
import DesignerDashboard from "./DesignerDashboard";
import PrintDashboard from "./PrintDashboard";
import BurhanDashboard from "./BurhanDashboard";
import AdminDashboard from "./AdminDashboard";
import RandDashboard from "./RandDashboard";
import JumanaDashboard from "./JumanaDashboard";
import SaraDashboard from "./SaraDashboard";
import BaneenDashboard from "./BaneenDashboard";
import HalimaDashboard from "./HalimaDashboard"; // ✅ هذا السطر الصحيح
import JanatDashboard from "./JanatDashboard";
import Login from "./Login";
import Navbar from "./Navbar";
import { Container } from "@mui/material";
import TasksDashboard from "./TasksDashboard";
import TasksRand from "./TasksRand";
import JumanaTasks from "./JumanaTasks";
import YusufTasks from "./YusufTasks";
import SaraTasks from "./SaraTasks";
import MaryamTasks from "./MaryamTasks";
import BaneenTasks from "./BaneenTasks";
import BurhanTasks from "./BurhanTasks";
import TodoBoard from "./TodoBoard";
import PartnerDashboard from "./PartnerDashboard";
import AnwarTasks from "./AnwarTasks";
import ChartsDashboard from "./ChartsDashboard";
import BurhanExpenses from "./BurhanExpenses";
import InvoiceStats from "./InvoiceStats";
import InvoicePage from "./InvoicePage";
import InvoiceListPage from "./InvoiceListPage";
import PartnerAddOrder from "./PartnerAddOrder";
import PartnerDashboardMitham from "./PartnerDashboardMitham";
import CompareBoards from "./CompareBoards";
import InvoiceViewPage from "./InvoiceViewPage";
import ProposalListPage from "./proposals/ProposalListPage";
import ProposalEditorPage from "./proposals/ProposalEditorPage";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
// ✅ Phase 07-D: أُزيل import orphaned لـInvoiceVersionEdit - كان مستورَداً
// هنا بدون أي استخدام JSX بالملف إطلاقاً (تأكدت مباشرة قبل الحذف). الراوت
// /invoice/version/edit/:invoiceId/:versionId يعرض <InvoicePage /> فعلياً،
// وليس <InvoiceVersionEdit />. الملف نفسه (InvoiceVersionEdit.jsx) لم يُحذف
// ولم يُربَط - بقي dead code موثَّق (راجع تعليق أعلى الملف نفسه)، لتفادي أي
// مخاطرة حذف. حذف هذا الـimport وحده آمن 100% (لا استخدام JSX له إطلاقاً)
// ولا يغيّر أي سلوك.
import ProtectedRoute from "./ProtectedRoute";
import CustomerSurveyForm from "./CustomerSurveyForm";
import CustomerSurveyList from "./CustomerSurveyList";
import CustomerSurveyImagesAdmin from "./CustomerSurveyImagesAdmin";

import BaneenInventory from "./BaneenInventory";
import AccountantDashboard from "./AccountantDashboard";
import PartnerSaraDashboard from "./PartnerSaraDashboard";
import CanvasCostCalculator from "./CanvasCostCalculator";
import ArchivedOrdersToDirect from "./ArchivedOrdersToDirect";
import LeaveRequest from "./LeaveRequest";
import LeaveAdmin from "./LeaveAdmin";
import MaterialRequestForm from "./MaterialRequestForm";
import MaterialRequestsAdmin from "./MaterialRequestsAdmin";
import ProjectCostCalculator from "./ProjectCostCalculator";
import MaryamDashboard from "./MaryamDashboard";
import SystemHistoryDashboard from "./SystemHistoryDashboard";
import SiteVisitDashboard from "./SiteVisitDashboard";
import FrameInvoiceSystem from "./FrameInvoiceSystem";
import LeadsDashboard from "./LeadsDashboard";
import KarinaDashboard from "./KarinaDashboard";
import KarinaTasks from "./KarinaTasks";
import FarahDashboard from "./FarahDashboard";
import FarahTasks from "./FarahTasks"; // إذا عندها مهام
import ApprovalDashboard from "./ApprovalDashboard"; // ✅ هذا السطر
import MaysaDashboard from "./MaysaDashboard"; // ✅ هذا السطر
import MaysaTasks from "./MaysaTasks"; 
// ✅ هذا السطر
import PartnersInventory from "./PartnersInventory";// ✅ هذا السطر
import StoryVideosDashboard from "./StoryVideosDashboard";
import AllStageVideosDashboard from "./AllStageVideosDashboard";
import SecondaryPartnerInventory from "./SecondaryPartnerInventory";
import SmartAccountingSystem from "./SmartAccountingSystem";
import ArtikaAI from "./ArtikaAI";
import AIPromptAdmin from "./AIPromptAdmin";
import ModelArena from "./ModelArena";
import UserPermissionsDashboard from "./UserPermissionsDashboard";
import StaffWorkspace from "./StaffWorkspace";
import MyTasks from "./MyTasks";
import GlobalImageViewer from "./components/GlobalImageViewer";
import { isPathHiddenForMe } from "./utils/accountBuiltIns";
import { apiFetch, API_BASE } from "./utils/apiClient";
import { saveProfile, clearProfile, isBoxAccount } from "./utils/userProfile";
function getHomeRoute(username) {
  // حسابات البوكسات (بما فيها حساب قديم انحوّل - مثل كارينا ← تيهان) لوحتها /workspace
  if (isBoxAccount()) return "/workspace";
  switch (username) {
    case "rand@123":
      return "/rand";
    case "jumana@123":
      return "/jumana";
    case "sara@123":
      return "/sara";
       case "maryam@123":
      return "/maryam";
    case "Baneen@123":
      return "/Baneen";
    case "designer@123":
      return "/designer";
    case "print@123":
      return "/print";
    case "art@1234":
      return "/burhan";
    case "admin":
      return "/admin";
    case "halima@123":
      return "/halima";
      case "farah@123":
  return "/farah";
      case "mohamed@123":
      return "/mohamed";
    default:
      // حسابات البوكسات (الجديدة) لوحتها /workspace
      return isBoxAccount() ? "/workspace" : "/login";
         case "arttouch@123":
      return "/partner"; 
       case "mitham@123":          // ✅ هذا السطر
      return "/partner-mitham"; 
      case "karina@123":
  return "/karina";// ✅
  case "maysa@123":
  return "/maysa";
  
      
  }
}

// كل أسماء المستخدمين المعروفة بالنظام (مطابقة لـusernameToEmail بالباك اند) -
// تُستخدم لصفحات لازم تتطلب تسجيل دخول فقط بدون تقييد مستخدم معيّن
// (Phase 04A، قرار 4: /todo و/project-cost)
const ALL_KNOWN_USERS = [
  "rand@123", "jumana@123", "sara@123", "Baneen@123", "designer@123",
  "art@1234", "print@123", "halima@123", "mohamed@123", "admin",
  "arttouch@123", "mitham@123", "osama@123", "ms.sara", "maryam@123",
  "farah@123", "karina@123", "frame@123", "maysa@123",
];

// نفس مجموعة المستخدمين اللي عندها فعلياً روابط تنقّل لصفحات الفواتير/عروض
// الأسعار بـNavbar.js (rand/maryam/farah/maysa/Baneen + admin عبر قائمة
// isAdmin المنفصلة) - Step Zero: Protect Accounting/Invoice/Proposal Routes،
// اعتمدت على الأزرار الموجودة فعلياً بـNavbar.js بدل اختراع مجموعة جديدة.
const INVOICE_PROPOSAL_USERS = [
  "admin", "Baneen@123", "rand@123", "maryam@123", "farah@123", "maysa@123",
];

// صفحة زرها انشال من صلاحية المستخدمين (utils/accountBuiltIns.js) - يرجّعه
// للوحته الأساسية بدل ما يفتحها برابط مباشر
function HiddenPageGuard({ username }) {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (username !== "admin" && isPathHiddenForMe(location.pathname)) {
      navigate("/", { replace: true });
    }
  }, [location.pathname, username, navigate]);
  return null;
}

function App() {

const [username, setUsername] = useState(() => {
  return localStorage.getItem("username");
});
// يرتفع كلما انحدّثت بيانات المستخدم من السيرفر حتى ينرسم الناف بار من جديد
const [, setProfileVersion] = useState(0);

// 🔄 تحديث بيانات المستخدم (الاسم الظاهر/البوكسات/الواجهات الإضافية) من
// السيرفر عند فتح التطبيق - حتى تنعكس تعديلات المدير بدون خروج ودخول
useEffect(() => {
  if (!username) return;
  let alive = true;
  apiFetch(`${API_BASE}/me/profile`)
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      if (!alive || !data) return;
      saveProfile(data);
      setProfileVersion((v) => v + 1);
    })
    .catch(() => {});
  return () => {
    alive = false;
  };
}, [username]);

// 🔐 إذا ماكو تسجيل دخول
if (!username) {
  return <Login onLogin={setUsername} />;
}

const handleLogout = () => {
  localStorage.removeItem("username");
  localStorage.removeItem("uid");
  localStorage.removeItem("authToken");
  localStorage.removeItem("grantedDashboards");
  clearProfile();
  // ✅ ينهي جلسة Firebase Auth نفسها (وليس بس localStorage) - بدونها يبقى
  // auth.currentUser مسجّل دخول بالـSDK فيقدر apiFetch يرفق توكن صالح لطلب
  // لاحق حتى بعد "تسجيل الخروج" بالواجهة.
  signOut(auth).catch((err) => console.error("Firebase sign-out error:", err));
  setUsername(null);
};

// ✅ إذا المستخدم على صفحة /login لا نعرض Navbar ولا أي شي ثاني




  return (
    <>
      <Navbar username={username} onLogout={handleLogout} />
      {/* 🖼️ أي صورة مرفوعة بأي واجهة تنفتح بالكبير بضغطة */}
      <GlobalImageViewer />
      <HiddenPageGuard username={username} />
      <Container sx={{ mt: 4 }}>
        <Routes>
<Route path="/" element={<Navigate to={getHomeRoute(username)} replace />} />
          <Route path="/add" element={<AddOrder />} />
<Route
  path="/designer"
  element={
    <ProtectedRoute allowedUsers={["designer@123", "admin", "Baneen@123"]}>
      <DesignerDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/print"
  element={
    <ProtectedRoute allowedUsers={["print@123", "admin", "Baneen@123"]}>
      <PrintDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/story-videos"
  element={
    <ProtectedRoute allowedUsers={["admin", "maysa@123", "Baneen@123"]}>
      <StoryVideosDashboard />
    </ProtectedRoute>
  }
/>
<Route path="/all-stage-videos" element={<AllStageVideosDashboard />} />

<Route path="/secondary-partners" element={<SecondaryPartnerInventory />} />


<Route path="/compare-boards/:orderId" element={<CompareBoards />} />
<Route
  path="/farah"
  element={
    <ProtectedRoute allowedUsers={["farah@123", "admin"]}>
      <FarahDashboard />
    </ProtectedRoute>
  }
/>
{/* Step Zero: قبل هذا التعديل كان هذا الـroute بدون أي ProtectedRoute
    إطلاقاً - أي حساب موظف مسجّل دخول (بغض النظر عن دوره) يقدر يفتح النظام
    المحاسبي كامل بمجرد كتابة الرابط يدوياً (Final Backend Completion Sweep
    Report، البند 3). المجموعة أدناه = admin + Baneen@123 فقط، اعتماداً على
    دليلين فعليين موجودين بالكود أصلاً (لم أخترعهما): SmartAccountingSystem.js
    نفسه يعامل Baneen@123 بمنطق خاص داخلي (isBaneen)، وBaneenDashboard.js فيه
    زر تنقّل حقيقي لـ/accounting. لا مستخدم آخر عنده أي رابط تنقّل لهذي الصفحة
    بأي مكان بالمشروع. */}
<Route
  path="/accounting"
  element={
    <ProtectedRoute allowedUsers={["admin", "Baneen@123"]}>
      <SmartAccountingSystem />
    </ProtectedRoute>
  }
/>

<Route
  path="/burhan"
  element={
<ProtectedRoute allowedUsers={["art@1234", "Baneen@123", "admin"]}>
      <BurhanDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin"
  element={
    <ProtectedRoute allowedUsers={["admin"]}>
      <AdminDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/user-permissions"
  element={
    <ProtectedRoute allowedUsers={["admin"]}>
      <UserPermissionsDashboard />
    </ProtectedRoute>
  }
/>
<Route path="/system-history" element={<SystemHistoryDashboard />} />
<Route
  path="/frame-invoices"
  element={
    <ProtectedRoute allowedUsers={["frame@123", "admin"]}>
      <FrameInvoiceSystem />
    </ProtectedRoute>
  }
/>
<Route path="/leads" element={<LeadsDashboard />} />
<Route path="/approval" element={<ApprovalDashboard />} />
<Route
  path="/leave-request"
  element={
    <ProtectedRoute allowedUsers={["Baneen@123","sara@123","jumana@123","designer@123","print@123","halima@123","mohamed@123","maryam@123","admin" ,"karina@123", "farah@123", "maysa@123", "art@1234"]}>
      <LeaveRequest />
    </ProtectedRoute>
  }
/>
<Route
  path="/leave-admin"
  element={
    <ProtectedRoute allowedUsers={["admin"]}>
      <LeaveAdmin />
    </ProtectedRoute>
  }
/>
<Route
  path="/material-request"
  element={
    <ProtectedRoute allowedUsers={["art@1234", "mohamed@123", "halima@123", "admin"]}>
      <MaterialRequestForm />
    </ProtectedRoute>
  }
/>
<Route
  path="/material-requests-admin"
  element={
    <ProtectedRoute allowedUsers={["admin", "Baneen@123"]}>
      <MaterialRequestsAdmin />
    </ProtectedRoute>
  }
/>

<Route
  path="/artika-ai"
  element={
    <ProtectedRoute
      allowedUsers={[
        "admin",
        "rand@123",
        "jumana@123",
        "sara@123",
        "Baneen@123",
        "farah@123",
        "designer@123",
        "print@123",
        "art@1234",
      ]}
    >
      <ArtikaAI />
    </ProtectedRoute>
  }
/>

<Route
  path="/ai-admin"
  element={
    <ProtectedRoute allowedUsers={["admin"]}>
      <AIPromptAdmin />
    </ProtectedRoute>
  }
/>
<Route
  path="/model-arena"
  element={
    <ProtectedRoute allowedUsers={["admin"]}>
      <ModelArena />
    </ProtectedRoute>
  }
/>
<Route
  path="/maryam"
  element={
    <ProtectedRoute allowedUsers={["maryam@123", "admin"]}>
      <MaryamDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/karina"
  element={
    <ProtectedRoute allowedUsers={["karina@123", "admin"]}>
      <KarinaDashboard />
    </ProtectedRoute>
  }
/>
<Route path="/archived-direct" element={<ArchivedOrdersToDirect />} />
<Route
  path="/site-visit"
  element={
    <ProtectedRoute allowedUsers={["jumana@123", "Baneen@123", "admin", "maryam@123", "karina@123", "farah@123", "maysa@123"]}>
      <SiteVisitDashboard currentUser={username} />
    </ProtectedRoute>
  }
/>



<Route
  path="/rand"
  element={
<ProtectedRoute allowedUsers={["rand@123", "admin"]}>
      <RandDashboard />
    </ProtectedRoute>
  }
/>
{/* مسجّل دخول وفتح /login (أو رجّعه ProtectedRoute لهنا): نرجعه للوحته
    بدل ما يعلك بفورم الدخول - إلا إذا ماله لوحة معروفة (حتى ما يصير loop) */}
<Route
  path="/login"
  element={
    getHomeRoute(username) !== "/login" && localStorage.getItem("authToken") ? (
      <Navigate to={getHomeRoute(username)} replace />
    ) : (
      <Login onLogin={setUsername} />
    )
  }
/>
{/* لوحة حسابات البوكسات (الجديدة): الموظفة نفسها، أو المدير لأي موظفة */}
<Route path="/workspace" element={<StaffWorkspace />} />
<Route
  path="/workspace/:accountId"
  element={
    <ProtectedRoute allowedUsers={["admin"]}>
      <StaffWorkspace />
    </ProtectedRoute>
  }
/>
<Route
  path="/my-tasks"
  element={
    <ProtectedRoute allowedUsers={[]}>
      <MyTasks />
    </ProtectedRoute>
  }
/>
<Route
  path="/canvas-cost"
  element={
    <ProtectedRoute allowedUsers={["Baneen@123", "sara@123","jumana@123","maryam@123","admin" ,"karina@123" ,"farah@123","maysa@123"]}>
      <CanvasCostCalculator />
    </ProtectedRoute>
  }
/>

<Route
  path="/jumana"
  element={
    <ProtectedRoute allowedUsers={["jumana@123", "admin","Baneen@123"]}>
      <JumanaDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/sara"
  element={
    <ProtectedRoute allowedUsers={["sara@123", "admin"]}>
      <SaraDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/customer-survey"
  element={
    <ProtectedRoute allowedUsers={["Baneen@123", "admin"]}>
      <CustomerSurveyForm />
    </ProtectedRoute>
  }
/>
<Route
  path="/customer-survey/list"
  element={
    <ProtectedRoute allowedUsers={["Baneen@123", "admin"]}>
      <CustomerSurveyList />
    </ProtectedRoute>
  }
/>
<Route
  path="/customer-survey/images"
  element={
    <ProtectedRoute allowedUsers={["Baneen@123", "admin"]}>
      <CustomerSurveyImagesAdmin />
    </ProtectedRoute>
  }
/>
<Route
  path="/Baneen"
  element={
    <ProtectedRoute allowedUsers={["Baneen@123", "admin"]}>
      <BaneenDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/halima"
  element={
    <ProtectedRoute allowedUsers={["halima@123", "admin"]}>
      <HalimaDashboard />
    </ProtectedRoute>
  }
/>
   


        <Route path="/tasks" element={<TasksDashboard />} />
  <Route path="/SaraDashboard" element={<SaraDashboard />} />
  <Route path="/SaraTasks" element={<SaraTasks />} />
  <Route path="/KarinaDashboard" element={<KarinaDashboard />} />
  <Route path="/KarinaTasks" element={<KarinaTasks />} />
<Route path="/burhan-expenses" element={<BurhanExpenses />} />
{/* Step Zero-B: /invoice-stats كانت بلا ProtectedRoute (نفس ثغرة /accounting
    وباقي مسارات الفواتير) - تُركت مفتوحة عمداً بـStep Zero الأولى فقط لأنها
    لم تكن بالقائمة الصريحة حينها. نفس مجموعة INVOICE_PROPOSAL_USERS لأنها
    نفس دومين الفواتير. */}
<Route
  path="/invoice-stats"
  element={
    <ProtectedRoute allowedUsers={INVOICE_PROPOSAL_USERS}>
      <InvoiceStats />
    </ProtectedRoute>
  }
/>
{/* Step Zero: /invoice و/invoices كانا بدون ProtectedRoute إطلاقاً - نفس
    ثغرة /accounting. المجموعة INVOICE_PROPOSAL_USERS مبنية من روابط تنقّل
    حقيقية موجودة أصلاً بـNavbar.js (rand/maryam/farah/maysa/Baneen +
    isAdmin). */}
<Route
  path="/invoice"
  element={
    <ProtectedRoute allowedUsers={INVOICE_PROPOSAL_USERS}>
      <InvoicePage />
    </ProtectedRoute>
  }
/>
<Route
  path="/invoices"
  element={
    <ProtectedRoute allowedUsers={INVOICE_PROPOSAL_USERS}>
      <InvoiceListPage />
    </ProtectedRoute>
  }
/>
 <Route path="/partner-add" element={<PartnerAddOrder />} />
   <Route path="/BaneenDashboard" element={<BaneenDashboard />} />
  <Route path="/BaneenTasks" element={<BaneenTasks />} />
        <Route path="/tasks-rand" element={<TasksRand />} />
  <Route path="/JumanaDashboard" element={<JumanaDashboard />} />
  <Route path="/JumanaTasks" element={<JumanaTasks />} />
  <Route path="/MaysaDashboard" element={<MaysaDashboard />} />
<Route path="/MaysaTasks" element={<MaysaTasks />} />
    <Route path="/BurhanTasks" element={<BurhanTasks />} />
    <Route path="/Burhan-Tasks" element={<BurhanDashboard />} />
<Route
  path="/todo"
  element={
    <ProtectedRoute allowedUsers={ALL_KNOWN_USERS}>
      <TodoBoard />
    </ProtectedRoute>
  }
/>
<Route path="/tasks-anwar" element={<AnwarTasks />} />
<Route path="/baneen-inventory" element={<BaneenInventory />} />
{/* Step Zero-B: بلا ProtectedRoute سابقاً. صفحة read-only مالية (تعرض
    accounting_pro) - لا يوجد أي زر تنقّل حقيقي لها بأي مكان بالمشروع ولا
    منطق username داخلي بالملف نفسه (بحثت ولم أجد دليلاً أقوى يخالف القاعدة
    المقترحة)، لذا نفس قاعدة /accounting بالضبط: admin + Baneen@123. */}
<Route
  path="/accountant"
  element={
    <ProtectedRoute allowedUsers={["admin", "Baneen@123"]}>
      <AccountantDashboard />
    </ProtectedRoute>
  }
/>
<Route path="/maryam-dashboard" element={<MaryamDashboard />} />
<Route path="/maryam-tasks" element={<MaryamTasks />} />
<Route path="/farah-dashboard" element={<FarahDashboard />} />
<Route path="/farah-tasks" element={<FarahTasks />} />

<Route path="/partners-inventory" element={<PartnersInventory />} />

  <Route path="/yusuf-dashboard" element={<DesignerDashboard />} />
   <Route path="/anwar" element={<AnwarTasks />} />
  <Route path="/yusuf-tasks" element={<YusufTasks />} />
  
<Route
  path="/partner"
  element={
    <ProtectedRoute allowedUsers={["arttouch@123", "admin"]}>
      <PartnerDashboard />
    </ProtectedRoute>
  }
/>
{/* طلب جديد من ارت تاتش - يروح فاتورة غير معتمدة لواجهة الفواتير */}
<Route
  path="/partner-order"
  element={
    <ProtectedRoute allowedUsers={["arttouch@123", "admin"]}>
      <PartnerAddOrder mode="order" />
    </ProtectedRoute>
  }
/>
{/* حساب سعر اللوحة - نسخة ارت تاتش المبسّطة (طول وعرض فقط) */}
<Route
  path="/partner-price"
  element={
    <ProtectedRoute allowedUsers={["arttouch@123", "admin"]}>
      <CanvasCostCalculator partnerMode />
    </ProtectedRoute>
  }
/>
   <Route path="/charts" element={<ChartsDashboard />} />
<Route
  path="/partner-mitham"
  element={
    <ProtectedRoute allowedUsers={["mitham@123", "admin"]}>
      <PartnerDashboardMitham />
    </ProtectedRoute>
  }
/>
{/* Step Zero: /invoice/edit/:invoiceId يعرض نفس InvoicePage بالضبط اللي
    صار محمياً أعلاه بـ/invoice - تركه بدون حماية كان يبقي ثغرة كاملة تتجاوز
    /invoice بمجرد تغيير الرابط لنفس الصفحة، لذلك أضيف هنا رغم أنه غير مذكور
    حرفياً بالطلب (نفس component، نفس الخطر بالضبط). /invoice/:id
    وinvoice/version/edit كذلك ضمن الطلب الصريح. */}
<Route
  path="/invoice/edit/:invoiceId"
  element={
    <ProtectedRoute allowedUsers={INVOICE_PROPOSAL_USERS}>
      <InvoicePage />
    </ProtectedRoute>
  }
/>
<Route
  path="/invoice/:id"
  element={
    <ProtectedRoute allowedUsers={INVOICE_PROPOSAL_USERS}>
      <InvoiceViewPage />
    </ProtectedRoute>
  }
/>
{/* عروض الأسعار (مولّد العروض بقالب أرتيكا الثابت) - نفس مستخدمي الفواتير
    + بوكس "عروض الأسعار" من صلاحية المستخدمين. المحرر نفسه يفتح كواجهة
    كاملة فوق الناف بار (src/proposals/ProposalEditorPage.jsx). */}
<Route
  path="/proposals"
  element={
    <ProtectedRoute allowedUsers={INVOICE_PROPOSAL_USERS}>
      <ProposalListPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/proposals/new"
  element={
    <ProtectedRoute allowedUsers={INVOICE_PROPOSAL_USERS}>
      <ProposalEditorPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/proposals/:id"
  element={
    <ProtectedRoute allowedUsers={INVOICE_PROPOSAL_USERS}>
      <ProposalEditorPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/invoice/version/edit/:invoiceId/:versionId"
  element={
    <ProtectedRoute allowedUsers={INVOICE_PROPOSAL_USERS}>
      <InvoicePage />
    </ProtectedRoute>
  }
/>

<Route
  path="/maysa"
  element={
    <ProtectedRoute allowedUsers={["maysa@123", "admin", "Baneen@123"]}>
      <MaysaDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/partner-sara"
  element={
    <ProtectedRoute allowedUsers={["ms.sara", "admin"]}>
      <PartnerSaraDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/project-cost"
  element={
    <ProtectedRoute allowedUsers={ALL_KNOWN_USERS}>
      <ProjectCostCalculator />
    </ProtectedRoute>
  }
/>


          <Route path="*" element={<Navigate to="/" />} />

          
<Route
  path="/mohamed"
  element={
    <ProtectedRoute allowedUsers={["mohamed@123", "admin"]}>
      <JanatDashboard />
    </ProtectedRoute>
  }
/>
        </Routes>
      </Container>
    </>
  );
}

export default App;
